module.exports = __webpack_public_path__ + "img/CoinbaseOnramp1.a6e0fbd3.png";